import { render, staticRenderFns } from "./PropertyCalendarWrapperTest.vue?vue&type=template&id=1ca5d1c2&scoped=true&"
import script from "./PropertyCalendarWrapperTest.vue?vue&type=script&lang=js&"
export * from "./PropertyCalendarWrapperTest.vue?vue&type=script&lang=js&"
import style0 from "./PropertyCalendarWrapperTest.vue?vue&type=style&index=0&id=1ca5d1c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca5d1c2",
  null
  
)

export default component.exports